/** Drop-in for `sonner`'s `toast` that loads the Toaster on first use and loses no call meanwhile. */
import { toast as sonnerToast } from 'sonner';
import { activateToaster, enqueueToast } from './toast-signal';

export const toast: typeof sonnerToast = new Proxy(sonnerToast, {
	apply(_target, _thisArg, args) {
		activateToaster();
		enqueueToast(() => Reflect.apply(sonnerToast, sonnerToast, args));
	},
	get(target, prop, receiver) {
		const value = Reflect.get(target, prop, receiver);
		if (typeof value === 'function') {
			return function (this: unknown, ...args: unknown[]) {
				activateToaster();
				enqueueToast(() => (value as (...a: unknown[]) => unknown).apply(target, args));
			};
		}
		return value;
	},
});
